<template>
  <a-card
      size="small"
      class="small-card-wrapper"
      :class="[{ 'is-locked': locked }]"
      :bordered="bordered"
  >
    <div class="small-card-wrapper__inner" :class="[`small-card-wrapper--${heightType}`]">
      <div class="small-card-wrapper__header">
        <span class="small-card-wrapper__name">
          {{ name }}
              <a-popover
                  v-if="hasLock"
                  :title="lockTitle"
                  trigger="hover"
                  placement="top"
              >
                <template #content>
                  <slot name="lock">
                    {{ lockText }}
                  </slot>
                </template>

              <LockFilled
                  class="small-card-wrapper__lock"
                  :class="{ 'is-active': locked }"
              />
          </a-popover>
        </span>

        <div class="small-card-wrapper__icons">
          <a-popover
              v-if="hasHelp"
              :title="helpTitle"
              trigger="hover"
              placement="top"
          >
            <template #content>
              <slot name="help">
                {{ helpText }}
              </slot>
            </template>

            <QuestionCircleOutlined class="small-card-wrapper__help" />
          </a-popover>
        </div>
      </div>

      <div class="small-card-wrapper__body">
        <a-spin v-if="loading" />
        <SubscriptionRequiredWarning v-else-if="locked" />
        <slot v-else />
      </div>
    </div>
  </a-card>
</template>

<script>
import { computed } from 'vue'
import {
  QuestionCircleOutlined,
  LockFilled,
} from '@ant-design/icons-vue'
import SubscriptionRequiredWarning from "@/components/OtherElements/SubscriptionRequiredWarning.vue";

export default {
  name: 'SmallCardWrapper',

  components: {
    SubscriptionRequiredWarning,
    QuestionCircleOutlined,
    LockFilled,
  },

  props: {
    name: {
      type: String,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    bordered: {
      type: Boolean,
      default: true,
    },

    showHelp: {
      type: Boolean,
      default: true,
    },

    helpTitle: {
      type: String,
      default: '',
    },

    helpText: {
      type: String,
      default: '',
    },

    showLock: {
      type: Boolean,
      default: false,
    },

    locked: {
      type: Boolean,
      default: false,
    },

    lockTitle: {
      type: String,
      default: 'Доступ закрыт',
    },

    lockText: {
      type: String,
      default: 'Оформите подписку',
    },
    heightType: {
      type: String,
      default: 'default',
    }
  },

  setup(props, { slots }) {
    const hasHelp = computed(() => {
      return props.showHelp && (props.helpText || slots.help)
    })

    const hasLock = computed(() => {
      return props.showLock || props.locked || slots.lock
    })

    return {
      hasHelp,
      hasLock,
    }
  },
}
</script>

<style scoped lang="scss">

.small-card-wrapper.is-locked .small-card-wrapper__inner {
  min-height: 60px;
}

.small-card-wrapper--small {
  min-height: 100px;
}

.small-card-wrapper--default {
  min-height: 155px;
}

.small-card-wrapper--medium {
  min-height: 280px;

  @media (max-width: $tablet-breakpoint) {
    min-height: auto;
  }
}

.small-card-wrapper__inner {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.small-card-wrapper {
  width: 100%;
}

.small-card-wrapper :deep(.ant-card-body) {
  padding: 0;
}

.small-card-wrapper__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  margin-bottom: 12px;
}

.small-card-wrapper__name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 600;
  color: var(--main-font);
}

.small-card-wrapper__icons {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
  color: rgba(0, 0, 0, 0.45);
}

.small-card-wrapper__help,
.small-card-wrapper__lock {
  cursor: pointer;
  font-size: 15px;
  transition: color 0.2s ease;
}

.small-card-wrapper__help:hover {
  color: var(--main-green);
}

.small-card-wrapper__lock.is-active {
  color: rgba(0, 0, 0, 0.25);
}

.small-card-wrapper__body {
  display: flex;
  align-items: center;
  justify-content: center;
}

.small-card-wrapper__body :deep(> *) {
  width: 100%;
}
</style>
